import React, { Component } from "react";

export default class ConfirmModal extends Component {
  render() {
    const {
      isOpen, darkMode, onClose,
      icon, iconVariant,
      title, message, subMessage,
      confirmLabel, confirmVariant,
      onConfirm,
    } = this.props;

    if (!isOpen) return null;

    const themeClass = darkMode ? "modal-dark" : "modal-light";
    const iconClass = iconVariant === "danger" ? "db-confirm-icon db-confirm-icon-danger" : "db-confirm-icon";
    const btnClass = confirmVariant === "danger" ? "db-confirm-btn db-confirm-btn-danger" : "db-confirm-btn db-confirm-btn-confirm";

    return (
      <div
        className={`db-confirm-overlay ${themeClass}`}
        onClick={onClose}
        role="dialog"
        aria-modal="true"
      >
        <div className={`db-confirm-modal ${themeClass}`} onClick={(e) => e.stopPropagation()}>
          <div className={iconClass}>
            {icon}
          </div>
          <h3 className="db-confirm-title">{title}</h3>
          <p className="db-confirm-text">{message}</p>
          {subMessage && <p className="db-confirm-subtext">{subMessage}</p>}
          <div className="db-confirm-actions">
            <button
              className="db-confirm-btn db-confirm-btn-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={btnClass}
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
